import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export default function formatDateToISO8601(date: Date): string {
  return dayjs(date).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
}
